import { URL_PATH } from '../../control-plane/constants';
import { journeyBuilderRoutes } from '../constants/JdRoutes';

export interface JourneyFormNavigationState {
  from?: string;
  path?: string | { path?: string };
  creatreNewEventButtonClicked?: boolean;
}

export const isCreateJourneyFlow = (pathName: string): boolean =>
  pathName.includes('/journeys/create') || pathName.includes('/create-journey');

/**
 * Resolves the destination when leaving the create-journey form.
 */
export const resolveJourneyFormBackPath = (locationState: unknown): string => {
  const queryParam = (locationState ?? null) as JourneyFormNavigationState | null;

  if (queryParam?.from) {
    return queryParam.from;
  }

  if (queryParam?.creatreNewEventButtonClicked) {
    return URL_PATH.DASHBOARD;
  }

  if (queryParam?.path && typeof queryParam.path === 'object' && queryParam.path.path) {
    const nestedPath = queryParam.path.path;
    return nestedPath.startsWith('/') ? nestedPath : `${journeyBuilderRoutes.viewJourney}${nestedPath}`;
  }

  if (typeof queryParam?.path === 'string') {
    if (queryParam.path.startsWith('/')) {
      return queryParam.path;
    }
    return `${journeyBuilderRoutes.viewJourney}${queryParam.path}`;
  }

  return journeyBuilderRoutes.viewJourney;
};

/**
 * Allowed exit paths for the create-journey navigation guard.
 */
export const getCreateJourneyExitPaths = (
  locationState: unknown,
  createJourneyPath = journeyBuilderRoutes.createJourney
): string[] => {
  const backPath = resolveJourneyFormBackPath(locationState);
  return backPath === createJourneyPath ? [backPath] : [backPath, createJourneyPath];
};
